// From https://github.com/h5bp/html5-boilerplate/issues/1985#issuecomment-394096182
// Referenced by https://medium.com/@matuzo/writing-css-with-accessibility-in-mind-8514a0007939
// Note that clip is deprecated so clip-path must be included for future-proofness
const visuallyHidden = () => `
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: auto;
  border: 0;
  padding: 0;
  margin: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%); 
  white-space: nowrap;
`;

// Cancels the effect of the above. Useful for showing the hidden element on :focus
// 'unset' resets a property to its inherited value if it inherits from its parent, and to its initial (default) value if not
// So you may need to manually overwrite these values in your code to set them to what you need, e.g. overflow-y: scroll
const notVisuallyHidden = () => `
  overflow: unset;
  position: unset;
  width: auto;
  height: auto;
  clip: auto;
  clip-path: none; 
  white-space: unset;
`;

export { visuallyHidden, notVisuallyHidden };
